import { render } from "./AdminEditTicket.vue?vue&type=template&id=d241aaac&scoped=true"
import script from "./AdminEditTicket.vue?vue&type=script&lang=js"
export * from "./AdminEditTicket.vue?vue&type=script&lang=js"

import "./AdminEditTicket.vue?vue&type=style&index=0&id=d241aaac&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d241aaac"]])

export default __exports__